module.exports = __webpack_public_path__ + "img/portable_wifi_off.88bcf8df.svg";